import React from 'react';
import PropTypes from 'prop-types';
import ContentCourseDetailService from '../services/ContentCourseDetailService';
import { toJS } from 'mobx';
import { observer } from 'mobx-react';
import ContentMasteryTestDetailScene from './ContentMasteryTestDetailScene';

class ContentMasteryTestDetailSceneContainer extends React.Component {
  static propTypes = {
    params: PropTypes.shape({
      courseId: PropTypes.string,
      moduleId: PropTypes.string,
      masteryTestId: PropTypes.string,
    }).isRequired,
  };

  contentCourseDetailService = new ContentCourseDetailService();
  componentDidMount() {
    this.contentCourseDetailService.handleLoadCourse(this.props.params.courseId);

    if (this.props.params.moduleId) {
      this.contentCourseDetailService.handleLoadModule(this.props.params.moduleId);
    }

    if (this.props.params.moduleId && this.props.params.masteryTestId) {
      this.contentCourseDetailService.handleLoadMasteryTest(
        this.props.params.moduleId,
        this.props.params.masteryTestId
      );
    }
  }

  shouldComponentUpdate(nextProps) {
    return JSON.stringify(nextProps.params) !== JSON.stringify(this.props.params);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.params.courseId !== this.props.params.courseId) {
      this.contentCourseDetailService.handleLoadCourse(this.props.params.courseId);
    }

    if (this.props.params.moduleId && this.props.params.moduleId !== prevProps.params.moduleId) {
      this.contentCourseDetailService.handleLoadModule(this.props.params.moduleId);
    }

    if (
      this.props.params.moduleId &&
      this.props.params.masteryTestId &&
      this.props.params.masteryTestId !== prevProps.params.masteryTestId
    ) {
      this.contentCourseDetailService.handleLoadMasteryTest(
        this.props.params.moduleId,
        this.props.params.masteryTestId
      );
    }
  }

  render() {
    return (
      <ContentMasteryTestDetailScene
        isLoading={
          this.contentCourseDetailService.fetchCourse.fetching ||
          this.contentCourseDetailService.fetchModule.fetching ||
          this.contentCourseDetailService.fetchMasteryTest.fetching ||
          (this.props.params.courseId && !toJS(this.contentCourseDetailService.course)) ||
          (this.props.params.moduleId && !toJS(this.contentCourseDetailService.module)) ||
          (this.props.params.masteryTestId && !toJS(this.contentCourseDetailService.masteryTest))
        }
        course={this.props.params.courseId && toJS(this.contentCourseDetailService.course)}
        module={this.props.params.moduleId && toJS(this.contentCourseDetailService.module)}
        masteryTest={this.props.params.masteryTestId && toJS(this.contentCourseDetailService.masteryTest)}
      />
    );
  }
}

export default observer(ContentMasteryTestDetailSceneContainer);
